/* esm.sh - rxjs@7.8.2/dist/esm/internal/Notification */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/Notification.mjs";
